import { z } from '@betty/toolkit/api';

export const DepositCountSchema = z.object({
  successfulDepositCount: z.number(),
});

export const BalanceTypeEnum = z.enum(['Bonus', 'Cash']);

export const UserBalanceSchema = z.object({
  type: BalanceTypeEnum,
  amount: z.number(),
});

export const UserBalancesSchema = z.object({
  playerId: z.number(),
  balances: z.array(UserBalanceSchema),
});

export const CoinBalanceSchema = z.object({
  playerId: z.number(),
  amount: z.number(),
});

export const AvailablePaymentProvidersSchema = z.object({
  deposits: z.array(z.string()),
  withdrawals: z.array(z.string()),
});

export const DepositApprovedEventDataSchema = z.object({
  playerId: z.number(),
  amount: z.number(),
  updatedAt: z.string(),
});

export type BalanceType = z.infer<typeof BalanceTypeEnum>;
export type AvailablePaymentProviders = z.infer<
  typeof AvailablePaymentProvidersSchema
>;
